import { FC } from 'react';
import { HOME_PITCH, type RichText } from '@puzzlio/core';
import { cn } from '@/app/lib/utils';

const CARD = 'rounded-xl border-4 border-black bg-white px-6 pt-6.5 pb-7 md:pt-7.5 md:pb-8';
const HEADING = 'font-chinook text-3xl leading-display';
const BODY = 'font-quicksand text-lg leading-snug font-medium text-black';
// Shared by both cards so they space alike: heading to first block, then block to block.
const FIRST_BLOCK = 'mt-4';
const NEXT_BLOCK = 'mt-5';

const Rich = ({ text }: { text: RichText }) =>
  text.map((run, index) =>
    typeof run === 'string' ? (
      run
    ) : (
      <b key={index} className="text-black">
        {run.bold}
      </b>
    )
  );

/** What a newcomer should know before their first puzzle: the deal, and how the week's difficulty runs. */
export const HomePitch: FC<{ className?: string }> = ({ className }) => {
  const { daily, difficulty } = HOME_PITCH;

  return (
    <div className={cn('grid grid-cols-1 gap-9 md:grid-cols-[3fr_2fr] md:gap-4', className)}>
      <section className={CARD}>
        <h2 className={HEADING}>{daily.title}</h2>
        <p className={cn(BODY, FIRST_BLOCK)}>{daily.intro}</p>
        {daily.perks.map((perk) => (
          <div key={perk.title} className={NEXT_BLOCK}>
            <h3 className="font-quicksand text-coral text-xl leading-tight font-bold">{perk.title}</h3>
            <p className={BODY}>{perk.body}</p>
          </div>
        ))}
      </section>

      <section className={CARD}>
        <h2 className={HEADING}>
          {difficulty.title.map((line) => (
            <span key={line} className="block">
              {line}
            </span>
          ))}
        </h2>
        {difficulty.paragraphs.map((paragraph, index) => (
          <p key={index} className={cn(BODY, index === 0 ? FIRST_BLOCK : NEXT_BLOCK)}>
            <Rich text={paragraph} />
          </p>
        ))}
      </section>
    </div>
  );
};
